
import { defineComponent } from "vue";

// 1. Twitter プロバイダ オブジェクトのインスタンスを作成します。
import {
  getAuth,
  signInWithRedirect,
  TwitterAuthProvider,
} from "firebase/auth";
const provider = new TwitterAuthProvider();

// 2. Twitter プロバイダ オブジェクトを使用して Firebase での認証を行います。
// ログインページにリダイレクトしてログインを行う場合は、signInWithRedirect を呼び出します。
const auth = getAuth();
signInWithRedirect(auth, provider);

export default defineComponent({
  name: "UserLogin",
});
